import { Link } from "react-router-dom";
import { renderStatus } from "../../../../../Utils/CommonUtils";
import { useEffect } from "react";
import { useState } from "react";

const useSelectedAgMappingColumns = (data) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  

  const handleCheckboxChange = (entityid) => {
    setSelectedRows((prevSelectedRows = []) =>
      prevSelectedRows?.includes(entityid)
        ? prevSelectedRows.filter((id) => id !== entityid)
        : [...prevSelectedRows, entityid]
    );
  };

  const handleSelectAllChange = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setSelectedRows(newSelectAll ? data?.map((row) => row.entityid) : []);
  };

  useEffect(() => {
    setSelectedRows([]);
    setSelectAll(false);
  }, [data]);

  useEffect(() => {
    setSelectAll(selectedRows?.length === data?.length);
  }, [selectedRows, data?.length]);

  const agMappingColumns = [
    {
      header: () => (
        <input
          type="checkbox"
          checked={selectAll}
          onChange={handleSelectAllChange}
        />
      ),
      accessorKey: "checkbox",
      cell: (props) => (
        <div>
          <input
            type="checkbox"
            checked={selectedRows?.includes(props.row.original.entityid)}
            onChange={() => handleCheckboxChange(props.row.original.entityid)}
          />
        </div>
      ),
      sortable: false,
    },
    {
      header: "Code",
      accessorKey: "code",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Created Date",
      accessorKey: "created_date",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    // {
    //   header: "Login Id",
    //   accessorKey: "login_id",
    //   cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
    //   size: 200,
    // },

    {
      header: "Status",
      accessorKey: "linked_status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 160,
    },
  ];

  return { agMappingColumns, selectedRows, selectAll };
};

export default useSelectedAgMappingColumns;
